import { useNavigate } from 'react-router-dom';
export function useProductNavigation() {
  const navigate = useNavigate();
  return (slug: string) => {
    if (slug) {
      navigate(`/product/${slug}`);
    }
  };
}
